import React from 'react';
import './SliderToggle.css'; // Importing the CSS below

const SliderToggle = ({ label, isOn, handleToggle, color = "#2196F3" }) => {
  return (
    <div className="toggle-wrapper">
      {label && <span className="toggle-label-text">{label}</span>}
      <label className="switch">
        <input 
          type="checkbox" 
          checked={isOn} 
          onChange={handleToggle} 
        />
        <span 
          className="slider round" 
          style={{ backgroundColor: isOn ? color : '#ccc' }}
        ></span>
      </label>
    </div>
  );
};

export default SliderToggle;